import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, createQueryKey, useAxiosClient, useQuery } from '@lumahealthhq/ui-model';
var basePath = 'faxDocumentWorkflows';
var crud = createCrud(basePath);

/* Default queries */
export var useFaxWorkflowsCount = crud.makeCount();
export var useFaxWorkflowsById = crud.makeFindById();
export var useFaxWorkflowsByIds = crud.makeFindByIds();
export var useFaxWorkflowsMany = crud.makeFindMany();
export var useFaxWorkflowsOne = crud.makeFindOne();
export var useFaxWorkflowsPagination = crud.makePagination();

/* Default mutations */
export var useFaxWorkflowsCreateOne = crud.makeCreateOne();
export var useFaxWorkflowsUpdateOne = crud.makeUpdateOne();
export var useFaxWorkflowsPatchOne = crud.makePatchOne();
export var useFaxWorkflowsRemoveById = crud.makeRemoveById();
var variant = 'v2/{basePath}';

/* Custom queries */
export function useFaxWorkflowActionsByCategoryId(categoryId, options) {
  var axiosClient = useAxiosClient();
  var url = "v2/".concat(basePath, "/actions/").concat(categoryId);
  function queryFn() {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$axiosClient$ge, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.get(url);
          case 2:
            _yield$axiosClient$ge = _context.sent;
            data = _yield$axiosClient$ge.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant, {
    categoryId: categoryId
  });
  var queryResult = useQuery(queryKey, queryFn, options);
  return queryResult;
}
export function useFaxWorkflowActionsPostExtraction(faxDocumentId, options) {
  var axiosClient = useAxiosClient();
  var url = "v2/faxDocumentActionInstances?faxDocument=".concat(faxDocumentId, "&stage=PostApproval");
  function queryFn() {
    return _queryFn2.apply(this, arguments);
  }
  function _queryFn2() {
    _queryFn2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _yield$axiosClient$ge2, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axiosClient.get(url);
          case 2:
            _yield$axiosClient$ge2 = _context2.sent;
            data = _yield$axiosClient$ge2.data;
            return _context2.abrupt("return", data);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _queryFn2.apply(this, arguments);
  }
  var queryKey = createQueryKey(basePath, variant, {
    _id: faxDocumentId
  });
  var queryResult = useQuery(queryKey, queryFn, options);
  return queryResult;
}

/* Custom mutations */